import { Vue } from "vue-property-decorator";
import _ from "lodash";

import { HttpService, QuestionnaireService } from "@/core/services";

export const AccountService = new Vue({
  methods: {
    async logout() {
      if (this.isImi() || this.isUser()) {
        await QuestionnaireService.undoCheckOutByUser();
      }

      this.$auth.logout();
      this.$eventHub.$emit("USER_UPDATED");
    },
    async refreshToken() {
      const response = await HttpService.get("account/refreshToken");

      this.setToken(response);

      return response;
    },
    unlock(userId: number) {
      return HttpService.put(`account/unlock/${userId}`);
    },
    authenticate(token: string) {
      // We need this wrapping method because the vue-auth library is stupid
      this.$auth.setToken({ data: { token } }, "token");
      this.$eventHub.$emit("USER_UPDATED");
    },
    setToken(tokenResponse: any) {
      this.$auth.setToken(tokenResponse);
      this.$eventHub.$emit("USER_UPDATED");
    },
    async loginAsImi() {
      const response = await HttpService.get("sso/loginAsImi");
      this.setToken(response);

      return response;
    },
    async loginAsEi() {
      const response = await HttpService.get("sso/loginAsEi");

      this.setToken(response);

      return response;
    },
    async loginAsUser() {
      const response = await HttpService.get("sso/loginAsUser");

      this.setToken(response);

      return response;
    },
    isPrivacyPolicyAccepted() {
      return HttpService.getData<boolean>(`account/isPrivacyPolicyAccepted`);
    },
    acceptPrivacyPolicy() {
      return HttpService.put(`account/acceptPrivacyPolicy`);
    },
    hasStartedQuestionnaire() {
      return HttpService.getData<boolean>(`account/hasStartedQuestionnaire`);
    },
    startQuestionnaire() {
      return HttpService.put(`account/startQuestionnaire`);
    },
    isAttendanceRecorded() {
      return HttpService.getData<boolean>(`account/isAttendanceRecorded`);
    },
    isInRole(roleName: string) {
      const token = this.$auth.getPayload();
      if (!token || !token.userRoles) {
        return false;
      }

      return _.includes(token.userRoles, roleName);
    },
    isAdmin() {
      return this.isImi() || this.isEi() || this.isDovetail();
    },
    isUser() {
      return this.isInRole("User");
    },
    isDovetail() {
      return this.isInRole("Dovetail");
    },
    isImi() {
      return this.isInRole("IMI");
    },
    isEi() {
      return this.isInRole("EI");
    },
  },
});
